import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common';
import { Clipboard } from '@/assets/icons';
import { flex, media } from '@/styles/theme';
import { NAVBAR_HEIGHT, SHIFTPICKUP_CART_HEADER_HEIGHT, SHIFTPICKUP_CART_TOP_SPACE } from '@/config/variables';

interface IPickedShiftsWithSuccess {
  onSubmit: () => void;
}

const PickedShiftsWithSuccess = ({ onSubmit }: IPickedShiftsWithSuccess): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ContainerBody>
      <StyledIcon src={Clipboard} />
      {t`mySchedule.pickUpShiftCart.labelShiftsSucessfullyPickedUp`}
      <StyledButton onClick={onSubmit} color="primary">
        {t`common.btnOk`}
      </StyledButton>
    </ContainerBody>
  );
};

export { PickedShiftsWithSuccess };

const ContainerBody = styled.div.attrs({
  className: `${flex.columnCenter} align-items-center pb-4 px-3`,
})`
  width: 100%;
  background-color: #f9fafb;
  border: 1px solid #f8f9fa;
  overflow: hidden auto;
  max-height: calc(
    90vh - 2 * ${SHIFTPICKUP_CART_HEADER_HEIGHT}px - ${NAVBAR_HEIGHT}px - ${SHIFTPICKUP_CART_TOP_SPACE}px
  );

  ${media.phone} {
    max-height: 400px;
  }
`;

const StyledButton = styled(Button)`
  width: 160px;
  margin: 20px 0;
`;

const StyledIcon = styled.img`
  width: 37.33px;
  height: 48px;

  margin: 30px 0;
`;
